var sw =  require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-gray-viz-render]').each(function() {
    var modelId = $(this).attr('data-sw-model-material-configurator-gray-viz-render');
    var el = this;

    require(
      [
        'vue',
        'vuex',
        'js/store',
        'rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorGrayRenderVizComponent/tpl.model-material-configurator-gray-render-viz-vue.mustache'
      ], function (vue, vuex, vuexStore, tpl) {
        /**
         * Vuex Store Module to provide actions and mutations for this component
         */
        vuexStore.registerModule('grayRenderVizComponent', {
          state: sw.data.vuexStoreState || {}, // add defaults here
          namespaced: true,
          mutations: {
            updateGrayRenderViz: function (state, payload) {
              state[payload.modelId].grayRenderVizStatus = payload.grayRenderVizStatus;
              state[payload.modelId].grayRenderGltfVizStatus = payload.grayRenderGltfVizStatus;
            }
          },
          actions: {
            grayRenderVizPolling: function (context, payload) {
              context.commit('updateGrayRenderViz', payload);
            }
          }
        });

        /**
         * Instantiate Vue root instance
         */
        new vue({
          el: el,
          data: {
            modelId: modelId
          },
          template: tpl.render(),
          created: function () {
            if (this.isVizProcessing) {
              this.pollForGrayRenderViz();
            }
          },

          store: vuexStore,
          computed: vuex.mapState({
            modelFileId: function(state) {
              return state[this.modelId].modelFileId
            },
            grayRenderVizStatus: function (state) {
              return state[this.modelId].grayRenderVizStatus;
            },
            grayRenderGltfVizStatus:function (state) {
              return state[this.modelId].grayRenderGltfVizStatus;
            },
            aoptPath: function (state) {
              return state[this.modelId].aoptPath;
            },
            gltfPath: function (state) {
              return state[this.modelId].gltfPath;
            },
            pictureUrl: function (state) {
              return state[this.modelId].pictureUrl;
            },
            isGltfVizAvailable: function () {
              return this.grayRenderGltfVizStatus === 'vizAvailable' && this.gltfPath !== null;
            },
            isVizAvailable: function () {
              return !this.isGltfVizAvailable && this.grayRenderVizStatus === 'vizAvailable' && this.aoptPath !== null;
            },
            isVizProcessing: function () {
              return this.grayRenderVizStatus === 'vizProcessing' && this.grayRenderGltfVizStatus === 'vizProcessing';
            },
            isVizUnavailable: function() {
              return !this.isVizAvailable && !this.isVizProcessing;
            },
            isGltfVizUnavailable: function() {
              return !this.isGltfVizAvailable && !this.isVizProcessing;
            },
            renderUpAxis: function (state) {
              return state[this.modelId].renderUpAxis;
            },
            renderRotation: function (state) {
              return (state[this.modelId].renderRotation).join(' ');
            }
          }),
          methods: {
            pollForGrayRenderViz: function () {
              var params = {
                'modelFileId': this.modelFileId
              };
              var self = this;
              sw.polling(
                '/model/gray-render-viz-status-polling',
                function (data) {
                  vuexStore.dispatch('grayRenderVizComponent/grayRenderVizPolling', {
                    grayRenderVizStatus: data.grayRenderVizStatus,
                    grayRenderGltfVizStatus: data.grayRenderGltfVizStatus,
                    modelId: self.modelId
                  });
                },
                2000,
                params
              );
            }
          }
        });
      });
  });
};
